import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { InspectionPointService, InspectionSectionService } from '../../../shared/services/index';
import { InspectionPoint } from '../../../shared/models/index';
import { BaseModalPageComponent } from '../../../base-modal.component';

@Component({
    templateUrl: './open-section.component.html',
    standalone: false
})
export class AddPointOpenSectionPageComponent extends BaseModalPageComponent implements OnInit {
  points: InspectionPoint[];
  inspectionId: string;
  sectionId: string;
  targetInspectionId: string;
  targetSectionId: string;
  selectedInspectionPoint: InspectionPoint;
  errorMessage: string;

  public loading: Boolean = true;

  constructor(
    public pointService: InspectionPointService,
    public sectionService: InspectionSectionService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      let id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      let sectionId = params['sectionId'];
      if (sectionId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.sectionId = sectionId;

      let targetInspectionId = params['targetInspectionId'];
      if (targetInspectionId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.targetInspectionId = targetInspectionId;

      let targetSectionId = params['targetSectionId'];
      if (targetSectionId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.targetSectionId = targetSectionId;

      this.initData();
    });
  }

  selectInspectionPoint(inspectionPoint: InspectionPoint): void {
    this.selectedInspectionPoint = inspectionPoint;
  }

  addPoint(): void {
    this.sectionService
      .addPoint(this.inspectionId, this.sectionId, this.targetInspectionId, this.selectedInspectionPoint.id)
      .subscribe((data) => {
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  initData(): void {
    this.pointService.getPoints(this.targetInspectionId, this.targetSectionId).subscribe((data) => {
      this.points = data;
      this.loading = false;
    });
  }
}
